import React, { useState, useEffect } from "react";
import Header from "./include/header";
import Footer from "./include/footer";
import UserLeftPanel from "./include/LeftPanel";
import axios from "axios";
import Global from "../APIConfig";
import { ToastContainer, toast } from '../components/ui/toast';
import { useNavigate, useParams, Link } from "react-router-dom";
import MainLoader from "./Loaders/MainLoader";
import AuthUser from "../AuthUser";
import { ArrowLeft, ShieldCheck, CreditCard, Gauge } from "lucide-react";


/**
 * CreditContent — credit limit cards + credit history table.
 * Used both by the standalone /CustomerCredit page and the /Finance hub tab.
 */
export function CreditContent() {
    let navigate = useNavigate();
    const { UniqueId } = useParams();
    const { headers1, headers2, logout } = AuthUser();
    const [Loading, setLoading] = useState(true);
    const [CreditHistory, setCreditHistory] = useState([]);
    const [gDefaultCurrency, setGDefaultCurrency] = useState('$');
    useEffect(() => {
        getCutomerCreditDetail();
    }, []);
    const items = JSON.parse(localStorage.getItem('user'));
    const getCutomerCreditDetail = () => {
        setLoading(true);
        axios({
            method: 'post',
            url: Global.baseUrl + 'getfrontCutomerCreditDetail',
            headers: headers1,
            data: {
                UniqueId: items.uniqueid,
            }
        })
            .then(function (response) {
                if (response.data.status == 200) {
                    var data = response.data.value;
                    setCreditHistory(data.history);
                    setGDefaultCurrency(data.gDefaultCurrency);
                }
                setLoading(false);
            })
            .catch(function (error) {
                if (error.response.status == 401) {
                    toast.error(error.response.statusText);
                    logout();
                    navigate('/');
                    window.location.reload();
                }
                setLoading(false);
            });
    }

    if (Loading) return <MainLoader />;

    const used = parseFloat(items.credit_limit - items.available_credit).toFixed(2);

    return (
        <>
            <div className="px-pagehead">
                <div className="px-pagehead__left">
                    <button className="px-btn px-btn--ghost px-btn--sm" onClick={() => navigate(-1)} aria-label="Go back">
                        <ArrowLeft size={16} />
                    </button>
                    <h2 className="px-pagehead__title">Credit Line</h2>
                </div>
            </div>

            <p className="px-finance-help">
                Your credit facility with Pram Express — the Limit extended to you and how much
                you have Used on Credit / Contract shipments. Available is what you can still use.
            </p>

            <div className="px-stat-grid">
                <div className="px-card px-card--stat">
                    <span className="px-stat__icon"><ShieldCheck size={22} /></span>
                    <div>
                        <div className="px-stat__value">{gDefaultCurrency}{items.available_credit}</div>
                        <div className="px-stat__label">Available Credit</div>
                    </div>
                </div>
                <div className="px-card px-card--stat">
                    <span className="px-stat__icon"><CreditCard size={22} /></span>
                    <div>
                        <div className="px-stat__value">{gDefaultCurrency}{items.credit_limit}</div>
                        <div className="px-stat__label">Credit Limit</div>
                    </div>
                </div>
                <div className="px-card px-card--stat">
                    <span className="px-stat__icon"><Gauge size={22} /></span>
                    <div>
                        <div className="px-stat__value">{gDefaultCurrency}{used}</div>
                        <div className="px-stat__label">Used Credit</div>
                    </div>
                </div>
            </div>

            <div className="px-table-wrap">
                <table className="px-table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Entry Date</th>
                            <th>Transaction Id</th>
                            <th>Shipment ID</th>
                            <th>Type</th>
                            <th>Amount</th>
                            <th>Payment Detail</th>
                        </tr>
                    </thead>
                    {CreditHistory.length > 0 ?
                        <tbody>
                            {CreditHistory.map((history, index) => {
                                return (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td className="text-capitalize">{history.date}</td>
                                        <td className="text-capitalize">{history.pay_id}</td>
                                        <td className="text-capitalize">{history.shipment_id}</td>
                                        <td>
                                            <span className="px-badge px-badge--neutral">{history.Dr > 0 ? 'Credit used' : 'Payment'}</span>
                                        </td>
                                        <td>
                                            {history.Dr > 0 ?
                                                <span className="px-amount px-amount--dr">-{gDefaultCurrency}{history.Dr}</span>
                                                :
                                                <span className="px-amount px-amount--cr">+{gDefaultCurrency}{history.Cr}</span>
                                            }
                                        </td>
                                        <td className="text-capitalize">{history.detail}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                        :
                        <tbody>
                            <tr><td colSpan={7} className="px-table__empty">Record Not Found</td></tr>
                        </tbody>
                    }
                </table>
            </div>
        </>
    );
}

function CustomerCredit() {
    return (
        <>
            <UserLeftPanel />
            <main className="px-main">
                <Header />
                <ToastContainer />
                <div className="px-content">
                    <CreditContent />
                </div>
                <Footer />
            </main>
        </>
    );
}
export default CustomerCredit;
